import React, { useContext, useEffect, useRef, useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import { BlockOrUnbloackApi, editAdminUser, getAdminLists } from '../../Services/allApi';
import { Icon } from '@iconify/react/dist/iconify.js';
import Select, { components } from 'react-select';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import UpdateRole from './UpdateRole';
import TableRolesReadOnly from './TableRolesReadOnly';
import AddAdmins from './AddAdmins';
import { addcontext } from '../../ContextShare/ContextShare';
import { toast, ToastContainer } from 'react-toastify';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '85%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90%',
    overflowY: 'hidden' // Make the Box scrollable
};
const style2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function TableAdmin() {
    const {addUser,setAddUser} = useContext(addcontext)
    const [adminList, setAdminList] = useState()
    const[adminRowDetails,setAdminRowDetails]=useState()
    const [roleChanged,setRoleChanged]=useState(1)
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [open2, setOpen2] = useState(false);
    const [isEdited, setIsEdited] = useState(1)
    const [dataToEdit, setDataToEdit] = useState()
    const handleOpen2 = () => setOpen2(true);
    const handleClose2 = () => setOpen2(false);

    const rolesRef = useRef(null);  // Create a reference for the "Roles & Permissions" section
    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px',

                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',

            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',

            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,


                    // backgroundColor:'red'
                },
            },
        },


        // // when: row => row.year >= 2021,
        // style: {
        // 	backgroundColor: 'rgba(248, 148, 6, 0.9)',
        // 	color: 'white',
        // 	'&:hover': {
        // 		cursor: 'pointer',
        // 	},
        // },
    };

    const columns = [

        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,

        },
        {
            name: 'Id',
            selector: row => row.id,
            sortable: true,

        },
        {
            name: 'Update role',
            selector: row => row.updaterole,
            minWidth: '130px', // Adjust the width as needed
        // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
        maxWidth: '140px',
        },
        {
            name: 'First Name',
            selector: row => row.name,
            sortable: true,

        },
        {
            name: 'Last Name',
            selector: row => row.Lname,
            sortable: true,

        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Phone',
            selector: row => row.phone,
            sortable: true,
        },
        {
            name: 'Joined Date',
            selector: row => row.created_at,
            sortable: true,
        },
        {
            name: 'Role',
            selector: row => row.role,
            sortable: true,
            minWidth: '260px', // Adjust the width as needed
        // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
        maxWidth: '270px',
        },
        {
            name: 'Updated at',
            selector: row => row.updated_at,
            sortable: true,
        },
        {
            name: 'Is active',
            selector: row => row.is_active,
            sortable: true,
        },

        //    {
        //         name: 'Action',
        //         selector: row => row.Action,
        //         // sortable: true,
        //     },
    ];
    const handleScrollToRoles = () => {
        if (rolesRef.current) {
            rolesRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const adminListApi = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const result = await getAdminLists(reqHeader)
        console.log(result);
        setAdminList(result?.data?.results)
    }
    useEffect(() => {
        adminListApi()
    }, [roleChanged])

    const handleUpdateRole=(adminDetail)=>{
        handleOpen()
        setAdminRowDetails(adminDetail)
    }

    const handleBlockUnblock=async(item)=>{
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const res=await BlockOrUnbloackApi({id:item?.id},reqHeader)
        if (res.status == 200) {
            setRoleChanged(roleChanged+1)
            // setTimeout(() => {
            //     setHideButtonClicked(false)
            // }, 1500)
            toast.success(item?.is_active ? "User blocking successfull" : "User Unblock successfull")
        }
        else {
            toast.error(res?.response?.data?.message ?? "There was problem!!!")
        }
    }
// const[rolearray,setrolearray]=useState(['Admin','Video publishing','Video uploading','Metadata entry','proceedings uploading','proceedings publishing'])
    var data = []
    adminList && adminList?.map((item, index) => {
        const slno = index + 1
        const id = item?.id
        const name = item?.first_name;
        const Lname = item?.last_name;
        const email = item?.email
        const phone = item?.phone_number
        // const role = item?.role
        const role = (
    <div className='flex flex-row gap-1 text-xs h-24 flex-wrap items-center overflow-hidden'>
        {item?.role?.map((item) => (
            <span className='bg-blue-100 text-blue-900 px-1 py-1 rounded h-6'>{item}</span>
        ))}
    </div>
);

        const created_at = item?.created_at?.slice(0, 10)
        const updated_at = item?.updated_at?.slice(0, 10)
        const is_active = <div className='flex flex-row gap-1 items-center'>
            <Icon icon={`${item?.is_active ? 'fa-solid:check-circle' : 'fa-solid:times-circle'}`} style={{ color: `${item?.is_active ? 'green' : 'red'}` }} className='text-lg' />
            <p className={item?.is_active ? 'text-green-500' : 'text-red-500'}>{item?.is_active ? 'Active' : 'Inacitve'}</p>
        </div>

        const updaterole= <div className='flex flex-col justify-center items-center gap-1 py-1 '>
        <button className='flex flex-row justify-center items-center rounded cursor-pointer w-24 text-white py-1 gap-1'  style={{ backgroundColor: '#18A0FB'}} onClick={()=>handleEdit(item)} > <span>Edit</span> <Icon icon="bxs:edit" className='' /></button>
        <button className='flex flex-row justify-center items-center rounded cursor-pointer w-24 text-white py-1'  style={{ backgroundColor: '#18A0FB'}} onClick={()=>handleUpdateRole(item)}>update role </button>
        <button className={`flex flex-row justify-center items-center rounded cursor-pointer w-24 gap-1 py-1 ${item?.is_active?' text-red-500 border border-red-500 hover:text-white hover:bg-red-500':' text-green-500 border border-green-500 hover:text-white hover:bg-green-500'}`} onClick={()=>handleBlockUnblock(item)}><span>{item?.is_active?'Block':'Unblock'}</span><Icon icon="basil:user-block-outline" /></button>
            </div>
   
        


        const newObj = { id, slno, name, Lname, email, phone, role, created_at, updated_at, is_active,updaterole };
        data.push(newObj);
    })
    const handleRowClick = (row) => {
        alert(`Clicked on row with ID: ${row.id}`);
    };

    const handleEdit=(item)=>{
        setDataToEdit(item)
        handleOpen2()
        console.log(item);
        
    }
    
    const handleSubmitEdit=async()=>{
        // alert('f')
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        console.log(dataToEdit);
       const res= await editAdminUser(dataToEdit,reqHeader)
       if(res?.status==200){
        toast.success("Editing successfull")
       }
       else{
        toast.error(res?.response?.data?.message ?? "There was problem!!!")
       }
        
    }



    return (
        <>
        <>
        {!addUser?<div className='flex flex-col gap-5'>
            <DataTable
                title={<div className=' flex flex-row justify-between items-center'><p>Admin users list</p><button  onClick={handleScrollToRoles}  className='px-2 py-1 text-sm me-5 border-gray-400 border rounded-full bg-gray-200 hover:bg-gray-300 text-blue-500 hover:text-blue-700' >View Roles & Permissions</button></div>}
                columns={columns}
                data={data}
                customStyles={customStyles}
                pagination
                dense
                highlightOnHover
                selectableRowsHighlight
                // selectableRows
                // progressPending
                // progressComponent={<h1>load</h1>}

                // onRowClicked={handleRowClick}
            />
            {/* <div className='ps-4'><a href='https://docs.google.com/spreadsheets/d/1Fw07Zlz-QhhzkWaDlPdEn-rws4pLEPJZ/edit?usp=sharing&ouid=107860327017506671484&rtpof=true&sd=true' target='_blank' className='px-4 py-2 border-gray-400 border bg-gray-200 rounded hover:bg-gray-300 text-blue-500 hover:text-blue-700' >Roles & Permissions</a></div>
             */}
            <h3 ref={rolesRef}  className='roles text-blue-700 text-xl font-bold text-left ms-5'>Roles & Permissions</h3>
            <TableRolesReadOnly/>
            </div>
            :
            <AddAdmins/>
            }
        </>

<Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <UpdateRole detailsTable={adminRowDetails} handleCloseModalSS={handleClose} roleChanged={roleChanged} setRoleChanged={setRoleChanged}/>
                </Box>
            </Modal>

            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
                theme="light"
            />

<Modal
                open={open2}
                onClose={handleClose2}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style2}>
                    <div className='flex flex-col items-center justify-center w-full ' style={{fontFamily:'ropa sans'}}>

                        <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="first">First name</label>
                            <input
                                id='first'
                                // placeholder='Add new event'
                                value={dataToEdit?.first_name}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, first_name: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>
                        <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="sec">Last name</label>
                            <input
                                id='sec'
                                // placeholder='Add new event'
                                value={dataToEdit?.last_name}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, last_name: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>
                        <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="email">Email</label>
                            <input
                                id='email'
                                // placeholder='Add new event'
                                value={dataToEdit?.email}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, email: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>
                        <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="phone">Phone</label>
                            <input
                                id='phone'
                                // placeholder='Add new event'
                                value={dataToEdit?.phone_number}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, phone_number: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>
                        <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="pass">Password</label>
                            <input
                                id='pass'
                                // placeholder='Add new event'
                                value={dataToEdit?.password}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, password: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='flex flex-row justify-center mb-5 mt-10'>
                            <button className='px-4 py-2 bg-green-600 text-white rounded-full me-2' onClick={handleSubmitEdit}>Submit</button>
                            <button className='px-4 py-2 bg-success rounded-full ms-2' onClick={handleClose2}>Cancel</button>

                        </div>

                    </div>

                </Box>
            </Modal>
        </>
    )
}

export default TableAdmin